import {
  FONT_BASE,
  FONT_MAX,
  FONT_XS,
  FONT_WEIGHT_MEDIUM,
  FONT_WEIGHT_REGULAR,
  LINE_HEIGHT_BASE,
} from '../themeConstants'

const body = (size, weight, extra = {}) => ({
  fontFamily: 'var(--app-font-sans)',
  fontSize: size,
  lineHeight: LINE_HEIGHT_BASE,
  fontWeight: weight,
  letterSpacing: 0,
  ...extra,
})

export const typographyBody = {
  subtitle1: body(FONT_MAX, FONT_WEIGHT_MEDIUM),
  subtitle2: body(FONT_BASE, FONT_WEIGHT_MEDIUM),
  body1: body(FONT_BASE, FONT_WEIGHT_REGULAR),
  body2: body(FONT_BASE, FONT_WEIGHT_MEDIUM),
  caption: body(FONT_XS, FONT_WEIGHT_REGULAR),
  button: body(FONT_XS, FONT_WEIGHT_MEDIUM, { textTransform: 'none' }),
  overline: body(FONT_XS, FONT_WEIGHT_REGULAR, { textTransform: 'none' }),
}
